import { useCallback, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';

import { content, page } from '@content';
import { auth } from '@modules';
import { Form } from '@views';
// import { variables } from '@styles';
import { useLoader, validate, useWebTitle } from '@utils';
import { useAppDispatch, history } from '@store';
import {
  UserAgreement,
  // Icon
} from '@components';
import { Typography } from '@material-ui/core';

import { useStyles } from './Login.styles';
import { CopyrightFooter } from '@components';

export const Login = (): JSX.Element => {
  const styles = useStyles();
  const meta = auth.useMeta();
  const { isAgreementAccepted, id } = auth.useData();
  const dispatch = useAppDispatch();

  const [showUserAgreement, setShowUserAgreement] = useState(false);

  const [loginStatus, setLoginStatus] = useState(meta.status);

  useEffect(() => {
    setLoginStatus(meta.status);
  }, [meta.status]);
  useWebTitle(content.logIn);

  useLoader(meta);

  useEffect(() => {
    if (meta.status === 'success' && !isAgreementAccepted) {
      setShowUserAgreement(true);
    }
  }, [meta.status, isAgreementAccepted]);

  const handleSubmit = useCallback(
    async (query) => {
      const result = await dispatch(auth.thunk.login(query));

      if (!auth.thunk.login.fulfilled.match(result)) {
        return;
      }

      if (result.payload?.user.isAgreementAccepted) {
        // get last logged in user id and last route from localStorage
        const lastLoggedInUserId = localStorage.getItem('lastLoggedInUserId');
        const lastRoute = localStorage.getItem('lastRoute');

        // if last logged in user id is defined and not equal to current user
        // id, update it and redirect to the dashboard
        if (!lastLoggedInUserId || atob(lastLoggedInUserId) !== result.payload.user.id.toString()) {
          localStorage.setItem('lastLoggedInUserId', btoa(result.payload.user.id.toString()));
          history.push(page.dashboard);
        } else {
          history.push(lastRoute ?? page.dashboard);
        }
      }
    },
    [dispatch],
  );

  const handleAcceptTerms = useCallback(() => {
    dispatch(auth.thunk.acceptTerms(id));
  }, [dispatch, id]);

  const handleCloseTerms = useCallback(() => {
    dispatch(auth.thunk.logout());
    setShowUserAgreement(false);
  }, [dispatch]);

  return (
    <>
      <Box className={styles.login}>
        <Box className={styles.formWrapper}>
          <Form
            className={styles.form}
            // status={meta.status}
            status={loginStatus}
            requiredWarn={content.fillAllRequiredFieldsPlease}
            invalidWarn={meta.error?.message || content.invalidCredentials}
            // title={''}
            // description={content.accessYourAccount}
            fields={[
              {
                type: 'txt',
                id: 'email',
                label: content.email,
                required: true,
                validate: validate.email,
                // placeholder: textTemplate(content.enterYour, { value: content.email.toLowerCase() }),
              },
              {
                type: 'pwd',
                id: 'password',
                label: content.password,
                required: true,
                validate: validate.password,
                // placeholder: textTemplate(content.enterYour, { value: content.password.toLowerCase() }),
              },
            ]}
            buttons={[
              {
                isSubmit: true,
                label: content.logIn,
                color: 'primary',
                // iconRight: (
                //   <Icon.ArrowRightOutline stroke={variables.color.primary.white} className={styles.arrowIcon} />
                // ),
              },
            ]}
            links={[{ label: content.forgotYourPassword, to: page.passwordResetRequest }]}
            onSubmit={handleSubmit}
          />
          <CopyrightFooter />
        </Box>
        {meta.status === 'success' && !isAgreementAccepted && showUserAgreement && (
          <UserAgreement onAcceptTerms={handleAcceptTerms} onCloseTerms={handleCloseTerms} />
        )}
      </Box>
      <Box className={styles.newsCenter}>
        <Typography component="h2">Break through the email</Typography>
        <Typography component="h1">Personalization Pain Wall</Typography>
      </Box>
    </>
  );
};
